import * as React from 'react'

import { useData } from './useData'
import { NoCustomFields } from './NoCustomFields'
import type { OpenFormCallback } from '../CustomFieldForm'
import type { CustomField, CustomFieldOption } from '@sales-center/common'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

export type CustomFieldListProps = {
  openForm: OpenFormCallback
  openDelete: (id: number) => void
  customFields: CustomField[]
  customFieldOptions: CustomFieldOption[]
}

export function CustomFieldList(props: CustomFieldListProps) {
  const { customFields } = props

  const {
    fieldList,
    onClickAdd,
    disableAdd,
    maxCustomFields,
    remainingFields,
  } = useData(props)

  if (customFields.length === 0)
    return <NoCustomFields onClickAdd={onClickAdd} />

  return (
    <Box maxWidth={700} flexGrow={1}>
      <Box display="flex" mb={2} alignItems="center">
        <Box>
          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              lineHeight: '24px',
              letterSpacing: '0.15px',
            }}
          >
            Manage your Custom Fields
          </Typography>
          <Typography variant="caption">
            {remainingFields} out of {maxCustomFields} Custom Fields Available
          </Typography>
        </Box>

        <Button
          variant="contained"
          onClick={onClickAdd}
          disabled={disableAdd}
          sx={{
            ml: 'auto',
            width: '232px',
            height: '36px',
          }}
        >
          Add Custom Field
        </Button>
      </Box>

      {fieldList}
    </Box>
  )
}
